var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white",staticStyle:{"width":"100% !important","height":"100vh !important: overflow-y: hidden !important"},attrs:{"fluid":""}},[_c('quote-print')],1)}
var staticRenderFns = []

export { render, staticRenderFns }